import React from 'react';
import Button from 'react-bootstrap/Button';
import bannerAnimate from '../../image/banner/bannerAnimate.png';
import './Slider.css'
const Slider = () => {
    return (
        <div className="slider-img">
            <div className="container-fluid">
                <div className="row px-5">
                    <div className="col-lg-5 col-md-5 col-sm-12 col-12 mt-5 pt-5 text-white">
                        <div className="slider-left">
                            <h2 className="ml-auto fs-1">MERN Stack Developer</h2>
                            <p>Experience in analyzing Designing and integrating Developing and front-end  back end based applications. I Already Develop some website </p>

                            <div className="button-style">
                                <Button className="mx-3" variant="info">Get started</Button>
                                <Button className="mx-3" variant="outline-info"> <a href="https://drive.google.com/uc?id=1gSQaR0Yogl85z0_WahWdU1pmiO8ZOPyq&export=download" target="_blank">Download Resume</a></Button>
                            </div>
                        </div>

                    </div>
                    <div className="col-lg-7 col-md-7 col-sm-12 col-12">
                        <img className="img-fluid" src={bannerAnimate} alt="" />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Slider;